export function isServerRender() {
  return typeof window === 'undefined'
}

export function getPageSsgState(route, key) {
  return route?.meta?.state?.[key] || null
}

export function setPageSsgState(route, key, value) {
  if (!isServerRender() || !route?.meta) {
    return
  }

  route.meta.state = {
    ...(route.meta.state || {}),
    [key]: value
  }
}

export function shouldMarkImageLoaded(imageUrl) {
  return !imageUrl || isServerRender()
}
